<template>
  <UiAlert
    type="error"
    icon="common/gift-filled"
    :button-text="$t('notificationPanel.verify')"
    :text="alertText"
    :align-center="full"
    :full-size="full"
    is-button
    @button="goToVerification"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NothingVerified',
  props: {
    full: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('user', ['getToVerification']),
    ...mapGetters('promotions', ['get_bonusesListTriggered']),
    alertText() {
      return this.full 
        ? `${this.$t('notificationPanel.nothingVerifiedMessage')} ${this.get_sufficientVerificationBonusFs} ФС!`
        : this.$t('notificationPanel.nothingVerifiedMessageShort')
    },
    get_sufficientVerificationBonusFs() {
      if (!this.get_bonusesListTriggered?.sufficientVerification) return ''
      return this.get_bonusesListTriggered?.sufficientVerification[0]?.fs.spins_per_day || ''
    },
  },
  mounted() {
    if (!Object.keys(this.get_bonusesListTriggered).length)
      this.fetch_bonusesListTriggered()
  },
  methods: {
    ...mapActions('promotions', ['fetch_bonusesListTriggered']),
    //TODO: можливо потрібно буде переробити на відкриття модалки, не через урл
    goToVerification() {
      const path = this.getToVerification(this.$paths)
      this.$router.push(path)
    },
  },
}
</script>
